import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

const LineItemRowItem = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('line-item-row__item', className)
    }), children);
};
var LineItemRow = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('line-item-row', className)
    }), children);
};
LineItemRow.Item = LineItemRowItem;

export { LineItemRow };
//# sourceMappingURL=LineItemRow.js.map
